import {FilePreviewContainer, ImagePreview, PreviewContainer, PreviewList} from "./forsale-styles.jsx";
import React, {useEffect, useState} from "react";
import { ipfs2md5 } from "../../utils";
import { getForSale, getNFTMetadata } from "../../lib/api";
import {useNavigate} from "@tanstack/react-router";
import MetaModal from "../Collection/MetaModal.jsx";
import {Modal2} from "../../components/Modal"
import {toast} from "react-toastify";

/**
 * ItemsForSale component.
 *
 * Displays a grid of NFT items that the user currently has listed for sale.
 * Fetches items from backend (getForSale) and loads metadata for each.
 * Shows preview images; clicking opens item details modal (MetaModal).
 * Shows "No items currently for sale" message if empty.
 *
 * @param {Object} props - Component props
 * @param {string|number} props.userid - Profile user's ID
 * @returns {React.ReactElement} Items for sale grid or empty message
 */
function ItemsForSale({userid}) {

    const [files, setFiles] = useState([])
    const [item, sItem] = useState()
    const [show, showModal] = useState(false);
    const [mContent, setMC] = useState("No Content Yet!")
    const [ud, setud] = useState(false)
    const [moT, setMoT] = useState();

    const navigate = useNavigate();

    const searchCall = async (myuserid) => {
        try {
            const out = await getForSale(myuserid);
            let c = out.account;
            if (c?.length) {
                let tmp = [];
                for (let i = 0; i < c?.length; i++) {
                    const itemData = await getNFTMetadata(c[i].id, c[i].tokenID);
                    if (!itemData?.metadata) continue;
                    let md = {};
                    try {
                        md = typeof itemData.metadata === 'string' ? JSON.parse(itemData.metadata) : itemData.metadata;
                    } catch (e) {
                        toast(e);
                        continue;
                    }
                    if (!md?.image) continue;
                    const url = ipfs2md5(md.image, true) + '.jpg';
                    let coll = c[i].id;
                    tmp.push({ coll, imgurl: url, meta: md });
                }
                setFiles(tmp);
            }
        } catch (error) {
            console.error('Failed to fetch items for sale:', error);
        } finally {
            setud(true);
        }
    };

    useEffect(() => {
        if (item) {
            setMoT(item[0]?.meta?.name)
            item[0]?.meta?.attributes ? MetaModal({
                item: item[0],
                setMC: setMC,
                showModal: showModal,
                doSearch: null,
                history: navigate
            }) : console.log("bad item")
        }
    }, [item])

    useEffect(() => {
        // Placeholder
    }, [ud,files])

    useEffect(()=>{
        setFiles(null)
        searchCall(userid)
    }, [userid])

    return (
        <>
            {!files?.length ? (
                <div className="pixel-card mt-3 mb-2">
                    <div className="card-header pb-0 p-3 pt-2">
                        <span className="mb-0 text-bold text-light">Items for Sale</span>
                    </div>
                    <div className="card-body text-center text-light opacity-75">
                        No items currently for sale
                    </div>
                </div>
            ) : (
                <div className="pixel-card mt-3 mb-2">
                    <div className="card-header pb-0 p-3 pt-2">
                        <span className="mb-0 text-bold text-light">Items for Sale</span>
                    </div>
                    <div className="card-body p-3">
                        <FilePreviewContainer>
                            <PreviewList id="pvList">
                                {files.map((file, index) => (
                                    <PreviewContainer key={index}>
                                        <Modal2 show={show} modalTitle={moT} content={mContent}/>
                                        <div>
                                            <ImagePreview
                                                onClick={() => {
                                                    sItem([files[index]])
                                                }}
                                                src={files[index].imgurl}
                                                alt={`Item preview ${index}`}
                                            />
                                        </div>
                                    </PreviewContainer>
                                ))}
                            </PreviewList>
                        </FilePreviewContainer>
                    </div>
                </div>
            )}
        </>
    )
}

export default ItemsForSale;
